import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ACCENT_MARK_CLASS } from '@/styles/accentMark';

interface DetailInfoCardProps {
  label: string;
  icon: LucideIcon;
  children: ReactNode;
}

export function DetailInfoCard({ label, icon: Icon, children }: DetailInfoCardProps) {
  return (
    <section
      aria-label={label}
      className="flex gap-3 rounded-2xl bg-card p-4 shadow-sm ring-1 ring-primary/10"
    >
      <span
        className={cn(
          'flex size-9 shrink-0 items-center justify-center rounded-xl',
          ACCENT_MARK_CLASS,
        )}
      >
        <Icon className="size-4.5" aria-hidden />
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-3">{children}</div>
    </section>
  );
}
